import {
  AgreementFulfillmentStatus,
  Agreements,
  ShipmentFulfillments,
} from '@etoh/database/core';
import { uniq } from 'lodash';
import { getUom } from '../shared/forms/uom';

/*
const getOrderedQuantity = (
  agreement: Agreements,
  shipmentFulfillments: ShipmentFulfillments[],
  status: ShipmentFulfillmentsStatus
) => {
  const shipmentFullmentsService = inject(ShipmentFullmentsService);

  return `${shipmentFullmentsService.getFulfillmentsQuantity(
    shipmentFulfillments,
    shipmentFullmentsService.getStatus(status)
  )} ${getUoms(shipmentFulfillments)}`;
};
*/

const getUoms = (shipmentFulfillments: ShipmentFulfillments[]) => {
  const uoms = uniq(
    shipmentFulfillments.map((s) => s.uom).filter((s) => s)
  ).map((uom) => getUom(uom));

  if (uoms.length > 1) {
    return `(${uoms.join(', ')})`;
  } else if (uoms.length === 1) {
    return uoms[0];
  }
  return '';
};

export const getFulfillmentsStatus = (
  agreement: Agreements,
  itemId: number | undefined = undefined
): AgreementFulfillmentStatus | null => {
  if (agreement.contractStatus !== 'approvedByParties') {
    return null;
  }

  const shipmentFulfillments = (agreement.shipmentFulfillments || []).filter(
    (s) => {
      if (itemId) {
        return s.itemId === itemId;
      }

      return true;
    }
  );

  if (shipmentFulfillments.length === 0) {
    return 'pendingFulfillment';
  }

  if (shipmentFulfillments.length > 0) {
    return 'partiallyFulfilled';
  }

  return null;
};
